export const PROPOSAL_ATTACHMENTS = [
  { key: "QUOTE", name: "Devis_Pro_Actif.pdf", size: "240 Ko" },
  { key: "IPID", name: "IPID_Pro_Actif.pdf", size: "180 Ko" },
];
